import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NotificationService } from '@app/shared/services/notification.service';
import { ErrorSnackbarComponent } from '../error-snackbar/error-snackbar.component';

@Component({
  selector: 'app-universal-snackbar',
  templateUrl: './universal-snackbar.component.html',
  styleUrls: ['./universal-snackbar.component.sass'],
})
export class UniversalSnackbarComponent {
  constructor(
    private readonly notificationSvc: NotificationService,
    public sbRef: MatSnackBarRef<ErrorSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  get getIcon() {
    return this.data?.icon;
  }

  get isSvg() {
    return this.data?.isSVG;
  }

  get class() {
    return this.data?.panelClass[0];
  }

  get description() {
    return this.data?.description;
  }

  getColor(type: string) {
    switch (type) {
      case 'snackbar-failure':
        return '#FF2525';
      case 'snackbar-success':
        return '#29D884';
      default:
        return '';
    }
  }

  onActionButton(): void {
    this.notificationSvc.onClickAction(true);
  }

  close() {
    this.sbRef.dismiss();
  }
}
